/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Endpoint_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "https://api.example.com/v1" |
*
* @param {Private_Models_Form_Endpoint_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_endpoint_url_placeholder = /** @type {((inputs?: Private_Models_Form_Endpoint_Url_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Endpoint_Url_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("https://api.beispiel.de/v1")
	return /** @type {LocalizedString} */ ("https://api.example.com/v1")
});